import HyperlinkPhoneNumber from "@/components/functionals/HyperlinkPhoneNumber.vue";
import ColorType from "@/components/functionals/ColorType.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";

export default [
  {
    prop: "Id",
    label: "No.",
    width: 120,
    align: "center",
    sortable: true
  },
  {
    prop: "ServiceRequestTypeDescription", //Prueba campo null, porfavor funciona!!!!!!!!!!!!!!
    label: "Tipo de Solicitud",
    width: 200,
    sortable: true
  },
  {
    prop: "ClientCode",
    label: "Código de Cliente",
    width: 160,
    sortable: true
  },
  // {
  //   prop: "SLA",
  //   label: "SLA",
  //   width: 80,
  //   sortable: true
  // },
  // {
  //   prop: "StatusDescription",
  //   label: "Estado",
  //   width: 130,
  //   sortable: true
  // },
  // {
  //   prop: "ClientCode",
  //   label: "Codigo del cliente",
  //   width: 180,
  //   sortable: true
  // },
  {
    prop: "CustomerName",
    label: "Nombre del Cliente",
    width: 250,
    sortable: true
  },
  // {
  //   prop: "ContactCode",
  //   label: "Codigo del contacto"
  // },
  {
    prop: "ContactName",
    label: "Contacto"
    //width: 250
  },
  {
    prop: "ContactPhoneNumber",
    label: "Teléfono del Contacto",
    formatter: HyperlinkPhoneNumber
  },
  {
    prop: "PendingToRateDays",
    label: "Dias sin calificar",
    minWidth: 150,
    align: "center",
    sortable: true,
    formatter: ColorType
  },
  {
    prop: "CustomerService",
    label: "Servicio al Cliente",
    width: 200,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "CustomerServiceImage"
    }
  },
  {
    prop: "AssignedTechnicianName",
    label: "Técnico Asignado",
    width: 250,
    formatter: ImagePerson,
    sortable: true,
    attrs: {
      imgKey: "AssignedTechnicianImageUrl"
    }
  }
];
